export default [
  {
    path: '/documentacao',
    name: 'Documentacao',
    component: () =>
      import('@/pages/Documentacao/Views/Documentacao/index.vue'),
  },
  {
    path: 'administracao',
    name: 'Administracao',
    component: () =>
      import('@/pages/Documentacao/Views/Administracao/index.vue'),
  },
  {
    path: 'administracao/indicadores-previne-brasil',
    name: 'IndicadoresPrevineBrasil',
    component: () =>
      import(
        '@/pages/Documentacao/Views/Administracao/IndicadoresPrevineBrasil/index.vue'
      ),
  },
  {
    path: 'administracao/gerenciar-usuarios',
    name: 'GerenciarUsuarios',
    component: () =>
      import(
        '@/pages/Documentacao/Views/Administracao/GerenciarUsuarios/index.vue'
      ),
  },
  {
    path: 'administracao/ressincronizacao',
    name: 'Ressincronizacao',
    component: () =>
      import(
        '@/pages/Documentacao/Views/Administracao/Ressincronizacao/index.vue'
      ),
  },
  {
    path: 'administracao/gerenciar-permissoes',
    name: 'GerenciarPermissoes',
    component: () =>
      import(
        '@/pages/Documentacao/Views/Administracao/GerenciarPermissoes/index.vue'
      ),
  },
  {
    path: 'cadastros-cidadaos',
    name: 'CadastrosCidadaos',
    component: () =>
      import('@/pages/Documentacao/Views/CadastrosCidadaos/index.vue'),
  },
  {
    path: 'indicadores-aps',
    name: 'IndicadoresAps',
    component: () =>
      import('@/pages/Documentacao/Views/IndicadoresAps/index.vue'),
  },
  {
    path: 'indicadores-aps/indicador-citologico',
    name: 'IndicadorCitologico',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/IndicadorCitologico/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/indicador-imunizacao',
    name: 'IndicadorImunizacao',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/IndicadorImunizacao/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/pre-natal',
    name: 'PreNatal',
    component: () =>
      import('@/pages/Documentacao/Views/IndicadoresAps/PreNatal/index.vue'),
  },
  {
    path: 'indicadores-aps/pre-natal/consultas-pre-natal',
    name: 'ConsultasPreNatal',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/PreNatal/ConsultasPreNatal/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/pre-natal/problemas-ativos',
    name: 'ProblemasAtivos',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/PreNatal/ProblemasAtivos/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/pre-natal/consultas-odontologicas',
    name: 'ConsultasOdontologicas',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/PreNatal/ConsultasOdontologicas/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/pre-natal/exames-hiv-sifilis',
    name: 'ExamesHivSifilis',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/PreNatal/ExamesHivSifilis/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/pre-natal/tres-indicadores-pre-natal',
    name: 'TresIndicadoresPreNatal',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/PreNatal/TresIndicadoresPreNatal/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/doencas-cronicas',
    name: 'DoencasCronicas',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/DoencasCronicas/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/doencas-cronicas/atendimento-diabetes',
    name: 'HemoglobinaGlicada',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/DoencasCronicas/HemoglobinaGlicada/index.vue'
      ),
  },
  {
    path: 'indicadores-aps/doencas-cronicas/atendimento-hipertensao',
    name: 'AtendimentoHipertensao',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/DoencasCronicas/AtendimentoHipertensao/index.vue'
      ),
  },
  {
    path: 'indicadores-aps/doencas-cronicas/hiper-dia',
    name: 'HiperDia',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/DoencasCronicas/HiperDia/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/resultado-isf-acs',
    name: 'ResultadoIsfAcs',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/ResultadoIsfAcs/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/desempenho-por-equipe',
    name: 'DesempenhoPorEquipe',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/DesempenhoPorEquipe/index.vue'
      ),
  },

  {
    path: 'indicadores-aps/desempenho-por-equipe/indicador',
    name: 'Indicador',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/DesempenhoPorEquipe/Indicador/index.vue'
      ),
  },
  {
    path: 'indicadores-aps/desempenho-por-equipe/geral',
    name: 'Geral',
    component: () =>
      import(
        '@/pages/Documentacao/Views/IndicadoresAps/DesempenhoPorEquipe/Geral/index.vue'
      ),
  },

  {
    path: 'gestao-cadastros',
    name: 'GestaoCadastros',
    component: () =>
      import('@/pages/Documentacao/Views/GestaoCadastros/index.vue'),
  },
  {
    path: 'gestao-cadastros/acs-por-cidadao',
    name: 'AcsPorCidadao',
    component: () =>
      import(
        '@/pages/Documentacao/Views/GestaoCadastros/AcsPorCidadao/index.vue'
      ),
  },
  {
    path: 'gestao-cadastros/busca-ativa-cadastro',
    name: 'BuscaAtivaCadastro',
    component: () =>
      import(
        '@/pages/Documentacao/Views/GestaoCadastros/BuscaAtivaCadastro/index.vue'
      ),
  },
  {
    path: 'gestao-cadastros/cidadaos-duplicados',
    name: 'CidadaosDuplicados',
    component: () =>
      import(
        '@/pages/Documentacao/Views/GestaoCadastros/CidadaosDuplicados/index.vue'
      ),
  },
  {
    path: 'gestao-cadastros/cadastros-sem-cpf',
    name: 'CadastrosSemCpf',
    component: () =>
      import(
        '@/pages/Documentacao/Views/GestaoCadastros/CadastrosSemCpf/index.vue'
      ),
  },
  {
    path: 'visitas-domiciliares',
    name: 'VisitasDomiciliares',
    component: () =>
      import('@/pages/Documentacao/Views/VisitasDomiciliares/index.vue'),
  },
  {
    path: 'visitas-domiciliares/cidadaos-visitados',
    name: 'CidadaosVisitados',
    component: () =>
      import(
        '@/pages/Documentacao/Views/VisitasDomiciliares/CidadaosVisitados/index.vue'
      ),
  },
  {
    path: 'visitas-domiciliares/familias-visitadas',
    name: 'FamiliasVisitadas',
    component: () =>
      import(
        '@/pages/Documentacao/Views/VisitasDomiciliares/FamiliasVisitadas/index.vue'
      ),
  },
  {
    path: 'visitas-domiciliares/desempenho-por-microarea',
    name: 'DesempenhoPorAcs',
    component: () =>
      import(
        '@/pages/Documentacao/Views/VisitasDomiciliares/DesempenhoPorMicroArea/index.vue'
      ),
  },
  {
    path: 'atendimentos-no-mes',
    name: 'AtendimentosNoMes',
    component: () =>
      import('@/pages/Documentacao/Views/AtendimentosNoMes/index.vue'),
  },
  {
    path: 'envio-app-acs-pec',
    name: 'EnvioAppAcsPec',
    component: () =>
      import('@/pages/Documentacao/Views/EnvioAppAcsPec/index.vue'),
  },
  {
    path: 'informatiza-aps',
    name: 'InformatizaAps',
    component: () =>
      import('@/pages/Documentacao/Views/InformatizaAps/index.vue'),
  },
  {
    path: 'risco-cardio-vascular',
    name: 'RiscoCardiovascular',
    component: () =>
      import('@/pages/Documentacao/Views/RiscoCardioVascular/index.vue'),
  },
]
